import Modal from 'react-bootstrap/Modal';
export const PriceRecalculate = ({ modalShow, setModalShow, RecalculatePrice ,HandleCancelRecalculate}) => {
    return (<>
        <Modal
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={modalShow}
            className="recalculate-modal-popup"
        >
            <Modal.Header>
                <div className="d-flex justify-content-between w-100">
                    <h5>
                        Confirm Changes
                    </h5>
                    <i className="fas fa-times" onClick={() => setModalShow(false)}></i>
                </div>
            </Modal.Header>
            <Modal.Body className='pt-0 pb-0'>
                <div className="row">
                    <div className="col-12">
                        <h4>Product Change Confirmation</h4>
                        <p>
                            Changing the product will trigger a price recalculation.
                            Are you sure want to proceed?
                        </p>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn cancel-btn" type="button" onClick={HandleCancelRecalculate}>Cancel</button>
                <button className="btn recalculate-btn" type="button" onClick={(e) => RecalculatePrice(e)}>
                    Recalculate
                </button>
            </Modal.Footer>
        </Modal>
    </>
    )
}
